var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('g-topic-subject',[_vm._t("default")],2),_c('p',{staticClass:"bg-white",domProps:{"innerHTML":_vm._s(_vm.htmlText)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }